import { TableRowData } from "./types";

export const transformObjectToTableRow = (data: any) => {
  if (data) {
    let returnObj: TableRowData[] = [];
    Object.values(data).map((item: any) => {
      if (item.value) {
        returnObj.push({ key: item.title, value: item.value });
      }
    });

    return returnObj;
  }

  return [];
};
